import { gridSizeMdLg3, gridSizeMdLg6, texto, TipoProductoEnumChoice, useLoaders, useTableColumnsProducto, useTableFilter, useTableServerSideFiltering } from "@/shared";
import { SearchComponente, GeneralTable, CustomAutocompleteNoForm, CustomTextFieldNoForm } from "@/shared/components/ui";
import { ScrollableDialogProps } from "@/shared/components/ui/Dialogs";
import { AlertSeverityEnum, IDataProducto, MaterialTransferido } from "@/shared/interfaces";
import { useCategoriaProductoStore } from "@/store/erp";
import { Button, Grid } from "@mui/material";
import { useState } from "react";
//import { Control } from "react-hook-form";

import { CATEGORYPRODUCT, IUbicacionProducto } from "@/shared/interfaces/erp/inventario";
import { Add } from "@mui/icons-material";
import { useUiStore } from "@/store/ui";
import { useFetchUbicacionProductoSimple } from "@/shared/actions/erp";
interface ModalUbProductoSelectTecnicoProps {
  //openModalProducto: boolean;
  //setOpenModalProducto: React.Dispatch<React.SetStateAction<boolean>>;
  // control: Control<any, any>;
  // onChange: (e: IDataProducto & Partial<MaterialTransferido>) => void;
  // ubicacion: string;
  enableCategoryRestriction?: boolean
  dataRestrictionCategories?: string[]
  onChange: (e: IDataProducto & Partial<MaterialTransferido>) => void;
  ubicacion: string;
  control?: any;
}


///* Componente para renderizar productos desde una ubicación

export default function ModalUbProductoSelectTecnico({
  onChange,
  ubicacion,
  // enableCategoryRestriction = false,
  // dataRestrictionCategories
  // ubicacion
}: ModalUbProductoSelectTecnicoProps) {
  const { categoriaProductos, isLoadingCategoriaProducto } = useCategoriaProductoStore();
  const [selectCategoria, setSelectCategoria] = useState<string | null>(null);
  // const [dataWithRestrictions, setDataWithRestrictions] = useState<CATEGORYPRODUCT[]>([]);

  const [openModalProducto, setOpenModalProducto] = useState<boolean>(false);

  const setAlert = useUiStore(s => s.setAlert);
  const { columnsCheckMovimientoInventarioTecnico } = useTableColumnsProducto();

  const {
    globalFilter,
    pagination,
    onChangeFilter,
    searchTerm,
    setPagination,
    cleanFilter,
    setGlobalFilter
  } = useTableFilter();

  const {
    filterObject,
    columnFilters, setColumnFilters
  } =
    useTableServerSideFiltering();

  const { pageIndex, pageSize } = pagination;

  const { data: dataUbicacionProd,
    isLoading: isloadingUbProducto,
    isRefetching: isRefetchingUbProducto
  } = useFetchUbicacionProductoSimple({
    //enabled: !!selectCategoria || !!searchTerm,
    //enabled:!!ubicacion,
    params: {
      page_size: pageSize,
      page: pageIndex + 1,
      descripcion_producto: searchTerm.toUpperCase(),
      //categoria_producto: selectCategoria,
      ubicacion: ubicacion,
      estado: true,
      ...filterObject,
      filterByState: false,
      ...(selectCategoria ? { categoria_producto: selectCategoria } : {})
    }
  });
  // useEffect(() => {
  //   if(enableCategoryRestriction){
  //     const auxCategoryProducts = categoriaProductos?.flatMap((item) =>
  //       dataRestrictionCategories?.includes(item.nombre) ? [item] : []
  //     )
  //     // setDataWithRestrictions(auxCategoryProducts)
  //   }

  // }, [categoriaProductos]);

  /* const { data: dataUbicacionProd,
    isLoading: isloadingUbProducto,
    isRefetching: isRefetchingUbProducto
  } = useFetchProductos({
    enabled: !!selectCategoria || !!searchTerm,
    params: {
      page_size: pageSize,
      page: pageIndex + 1,
      descripcion_producto: searchTerm.toUpperCase(),
      categoria_producto: selectCategoria,
      ubicacion: ubicacion,
      estado: true,
      ...filterObject,
      filterByState: false
    }
  }); */

  const categoriasConTodos = [
    { codigo: "", nombre: "TODOS" },
    ...(categoriaProductos || [])
  ]

  useLoaders(isloadingUbProducto);

  return (
    <>
      <Button
        variant="outlined"
        startIcon={<Add />}
        onClick={() => {
          if (!ubicacion) {
            setAlert(true, 'Seleccionar una ubicación origen para la solicitud.', AlertSeverityEnum.info);
            return;
          }
          setOpenModalProducto(true)
        }}
      >
        Agregar Items
      </Button>
      <ScrollableDialogProps
        open={openModalProducto}
        title="Seleccionar Inventariable"//Por Ubicación
        cancelTextBtn="Cerrar"
        onCloseIcon={() => {
          setSelectCategoria(null);
          setGlobalFilter("")
          cleanFilter();
          setOpenModalProducto(false);
        }}
        minWidth="60%"
        contentNode={
          <Grid container spacing={2}>
            <Grid item {...gridSizeMdLg6}>
              <SearchComponente
                onChange={onChangeFilter}
                value={globalFilter}
                text="por descripción" />
            </Grid>
            <Grid item {...gridSizeMdLg3}>
              <CustomTextFieldNoForm
                required={false}
                disabled={true}
                label="Tipo producto"
                value={TipoProductoEnumChoice.INVENTARIABLE}
                defaultValue={TipoProductoEnumChoice.INVENTARIABLE}
              />
            </Grid>
            <Grid item {...gridSizeMdLg3}>
              <CustomAutocompleteNoForm<CATEGORYPRODUCT | { codigo: string; nombre: string }>
                label={texto.categoria_producto}
                //options={categoriaProductos || []}
                options={categoriasConTodos}
                valueKey="nombre"
                actualValueKey="codigo"
                defaultValue={selectCategoria || ""}
                isLoadingData={isLoadingCategoriaProducto}
                onChangeRawValue={(e) => {
                  if (e) {
                    cleanFilter();
                    setSelectCategoria(e.codigo);
                    return
                  }
                  setSelectCategoria(null);

                }}
              />
            </Grid>
            <Grid item xs={12}>
              <GeneralTable<IUbicacionProducto>
                columns={columnsCheckMovimientoInventarioTecnico}
                data={dataUbicacionProd?.data.data || []}
                isLoading={isloadingUbProducto}
                isRefetching={isRefetchingUbProducto}
                enableGlobalFilter={false}
                pagination={pagination}
                onPaging={setPagination}
                rowCount={dataUbicacionProd?.data?.count}
                actionsColumnSize={60}
                canDelete={false}
                positionActionsColumn='first'
                enableColumnActions={true}
                canAdd={true}
                canEdit={false}
                onAdd={e => {

                  // Backend devuelve
                  // stock - stock ubicacion
                  // producto_data.stock_actual - stock global
                  // componente usa stock de ubicacion    

                  console.log(e);

                  const auxProducto = {
                    ...e!,
                    ...e.producto_data!,
                    metros_actuales: e.metros_actuales,
                    //contiene_serie: e.contiene_serie,
                    series: [],
                    stock_actual: e.stock ?? '0', // stock global se convierte en stock ubicacion para evitar confuciones
                  }

                  onChange(auxProducto as any);
                }}
                density="comfortable"
                enableTopToolbar={false}

                ///* filters - server side
                enableSorting={false}
                enableManualFiltering={true}
                columnFilters={columnFilters}
                onColumnFiltersChange={setColumnFilters}
              />
            </Grid>
          </Grid>
        }
      />
    </>
  );

}